import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class GlobalFlagsService {
    public loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public userLogged: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public showHeader: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
    public error: BehaviorSubject<any> = new BehaviorSubject<any>({});
    public alerts: Array<any> = [];
    public formName: string = '';
    public formLabel: string = '';
    public isFromLogin: boolean;
    public isPosthogEnabled: boolean = false;

    displayLoad(value: boolean) {
        this.loading.next(value);
    }

    displayHeader(value: boolean) {
        this.showHeader.next(value);
    }

    setUserLogged(value: boolean) {
        this.userLogged.next(value);
    }

    setError(value: any) {
        this.error.next(value);
    }

    setFormName(value: string) {
        this.formName = value;
    }

    setFormLabel(value: string) {
        this.formLabel = value;
    }

    setIsFromLogin(value: boolean) {
        this.isFromLogin = value;
    }

    pushSuccessAlert(data: any) {
        this.alerts = [];
        this.alerts.push({
            type: 'success',
            msg: data.message
        });
    }

    pushErrorAlert(data: any) {
        this.alerts = [];
        this.alerts.push({
            type: 'danger',
            msg: data.errorMsg
        });
    }

    cleanAlerts() {
        this.alerts = [];
    }

    setPosthogEnabled(value: boolean) {
        this.isPosthogEnabled = value;
    }

}
